import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw, ShieldCheck } from "lucide-react";
import { api, apiError } from "@/lib/api";

const KEY = "buzzly_meta_reconnect_later";
const snoozed = () => Date.now() - Number(localStorage.getItem(KEY) || 0) < 24 * 3600 * 1000;

export const MetaReconnectBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (snoozed()) return;
    api.metaConnection().then(c => setShow(!!c?.needs_reconnect)).catch(() => {});
  }, []);
  if (!show) return null;

  const reconnect = async () => {
    try { window.location.href = (await api.metaConnect(window.location.origin)).url; } catch (e) { toast.error(apiError(e)); }
  };
  const later = () => { localStorage.setItem(KEY, String(Date.now())); setShow(false); };

  return (
    <div className="card-surface flex flex-wrap items-center gap-4 px-5 py-4 border-l-4 !border-l-[#e1306c]" data-testid="meta-reconnect-banner">
      <span className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#1877f2] to-[#e1306c] grid place-items-center shrink-0"><ShieldCheck className="w-5 h-5 text-white" /></span>
      <div className="flex-1 min-w-[200px]">
        <p className="font-semibold text-sm">Nouveau : publication directe Facebook + Instagram, sans limite quotidienne</p>
        <p className="text-xs text-[#65676b]">Reconnectez votre compte Meta une fois et acceptez les nouvelles autorisations de publication.</p>
      </div>
      <div className="flex gap-2">
        <button type="button" className="btn-ghost" onClick={later} data-testid="meta-reconnect-later-btn">Plus tard</button>
        <button type="button" className="btn-primary" onClick={reconnect} data-testid="meta-reconnect-banner-btn"><RefreshCw className="w-4 h-4" /> Reconnecter</button>
      </div>
    </div>
  );
};
